export const config = {
  apiUrl:       process.env.REACT_APP_API_URL       || 'http://localhost:8000/api',
  appName:      process.env.REACT_APP_APP_NAME      || 'CryptoTrade Pro',
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || '#00ff88',
};
